"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _countryRegionData = _interopRequireDefault(require("country-region-data"));

var _default = function _default(_ref) {
  var _ref$OptionComponent = _ref.OptionComponent,
      OptionComponent = _ref$OptionComponent === void 0 ? 'option' : _ref$OptionComponent,
      _ref$SelectComponent = _ref.SelectComponent,
      SelectComponent = _ref$SelectComponent === void 0 ? 'select' : _ref$SelectComponent,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["OptionComponent", "SelectComponent"]);
  return /*#__PURE__*/_react["default"].createElement(SelectComponent, props, [{
    countryShortCode: 'US',
    countryName: 'United States',
    key: 'US-always-present',
    value: 'US'
  }].concat((0, _toConsumableArray2["default"])(_countryRegionData["default"])).map(function (_ref2) {
    var key = _ref2.key,
        countryShortCode = _ref2.countryShortCode,
        countryName = _ref2.countryName;
    return /*#__PURE__*/_react["default"].createElement(OptionComponent, {
      key: key || countryShortCode,
      value: countryShortCode
    }, countryName);
  }));
};

exports["default"] = _default;